import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { SupplierPromotion } from '../../types/supplier-promotion';
import { SupplierPrice } from '../../types/supplier-price';
import { IconComponent, IsDefinedNotEmptyPipe} from '@softline/ui-core';
import { PriceCardComponent } from '../price-card/price-card.component';

import { FormatPipe } from '@softline/ui-core';
@Component({
  selector: 'soft-supplier-price-card',
  imports: [
    PriceCardComponent,
    IconComponent,
    IsDefinedNotEmptyPipe,
    FormatPipe],
  templateUrl: './supplier-price-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supplier-price-card.component.css' })
export class SupplierPriceCardComponent {
  supplierPrice = input.required<SupplierPrice>();
  hideNetPriceIncl = input<boolean>(false);
}
